import { render, staticRenderFns } from "./anagrafica.html?vue&type=template&id=6f452ed2&scoped=true&"
import script from "./Anagrafica.vue?vue&type=script&lang=js&"
export * from "./Anagrafica.vue?vue&type=script&lang=js&"
import style0 from "./Anagrafica.vue?vue&type=style&index=0&id=6f452ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f452ed2",
  null
  
)

export default component.exports